import axios from "axios";
import config from "../../config/config";

const getQuizz = async (quizId, quizCulture) => {
    const request = axios.get(
        `${config.blendAppBaseUrl}/getquiz/${quizId}/${quizCulture}`
    );
    try {
        const response = await request;
        return response.data.questions;
    } catch (error) {
        throw new Error(error);
    }
};

const postQuizz = async (quizId, quizCulture, quizData) => {
    const request = axios.post(`${config.blendAppBaseUrl}/results/${quizId}/${quizCulture}`, quizData, {
        headers: {
            //"content-type": "multipart/form-data",
            "content-type": "application/json"
        },
    });
    try {
        const response = await request;
        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

export { getQuizz, postQuizz };
